import { render, staticRenderFns } from "./TaskAssignmentVersionCardContent.vue?vue&type=template&id=401f0f51&"
import script from "./TaskAssignmentVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./TaskAssignmentVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports